import _ from 'lodash';

// some array helper functions
Array.prototype.flatten = function() { return this.reduce((agg, val) => agg.concat(val), []); };
Array.prototype.extend = function(other) {
  if (_.isArray(other)) {
    for (let x = 0; x < other.length; ++x) {
      this.push(other[x]);
    }
  }
  else {
    this.push(other);
  }
  return this;
};
Array.prototype.unique = function() { return _.uniqBy(this, e => _.isRegExp(e) ? e.toString() : e); };

export const http_methods = {
  get: true,
  put: true,
  post: true,
  delete: true,
  head: true,
  options: true,
  patch: true
};


export function resolveUrls(hostname, hostwithsuffix){
  if (hostname === 'localhost'){
    return hostname;
  }
  const appName = hostname.indexOf('api-docs') === 0 ? 'api-docs' : 'docs';
  const startAt = appName.length;
  const endAt = hostname.indexOf('.');
  let _host = `${location.protocol}//${hostwithsuffix}${hostname.substring(endAt)}`;
  let suffix = '';
  if (!hostname || hostname.indexOf(appName) === -1){
    suffix = '';
  }
  else {
    suffix = hostname.substring(startAt, endAt);
  }
  // if we have something like console.dev.cloud.foreeye.com
  return _host.replace('$$suffix$$', suffix);
}
